module.exports = __webpack_public_path__ + "static/media/HelloNewFriendHeader.b5fddfe3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HelloNewFriendHeader.svg
// module id = 343
// module chunks = 0